import { QuoteDTO } from 'models/quote';

export default function customerTemplate({ clientInfo }: QuoteDTO) {
  if (clientInfo) {
    const { firstName, lastName } = clientInfo;
    return firstName || lastName ? `${firstName} ${lastName}` : '';
  }
  return '';
}
